<template>
  <div class="p-5 md:p-20 flex flex-col space-y-10">

    <div class="flex justify-between">
      <editable-headline :field="destination.pivot.id + '-eateries'" default="Eateries" :width="true"/>

      <button
          v-if="eateries.length > 0"
          @click="showModal = true"
          type="button"
          class="bg-button-purple text-white rounded-md text-sm py-1 px-2 border border-font hover:bg-primary"
      >
        + Add more
      </button>
    </div>
    <div v-if="eateries.length === 0" class="w-full flex flex-col justify-center items-center">
      <svg width="39" height="30" viewBox="0 0 39 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M13.5 17H25.5H13.5ZM19.5 11V23V11ZM1.5 25V5C1.5 3.93913 1.92143 2.92172 2.67157 2.17157C3.42172 1.42143 4.43913 1 5.5 1H17.5L21.5 5H33.5C34.5609 5 35.5783 5.42143 36.3284 6.17157C37.0786 6.92172 37.5 7.93913 37.5 9V25C37.5 26.0609 37.0786 27.0783 36.3284 27.8284C35.5783 28.5786 34.5609 29 33.5 29H5.5C4.43913 29 3.42172 28.5786 2.67157 27.8284C1.92143 27.0783 1.5 26.0609 1.5 25Z" stroke="#8E87C7" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <p class="mt-6 font-semibold">Add eatery</p>
      <p class="text-gray-600">Get started by choosing an eatery</p>
      <button
          @click="showModal = true"
          type="button"
          class="mt-10 bg-button-purple text-white rounded-md py-2 px-4 border border-font hover:bg-primary"
      >
        + Choose from list
      </button>
    </div>
    <div v-else class="w-full flex">
      <Cards
          @edit="editEatery"
          :cards="eateries"
      />
    </div>
  </div>

  <AddEateryModal
      :show="showModal"
      @cancel="cancel"
      :destination="destination"
      :size="`max-w-6xl`"
      @eatery="addEatery"
      @customEatery="addCustomEatery"
  />

  <EditEateryModal
      :eatery="edit"
      :proposal="store.proposal"
      :destination="destination"
      @cancel="edit = null"
      @delete="deleteEatery"
  />

</template>

<script setup>

import {computed, ref} from "vue";
import AddEateryModal from '@/ComponentsDeprecated/Modal/Proposal/AddEateryModal'
import EditEateryModal from "@/ComponentsDeprecated/Modal/Proposal/EditEateryModal";
import Cards from "@/ComponentsDeprecated/Cards/DestinationCards"
import {useProposalOldStore} from "@/Stores/ProposalOld";
import EditableHeadline from "@/ComponentsDeprecated/Proposal/EditableHeadline";

const showModal = ref(false)
const store = useProposalOldStore()

const props = defineProps({
  destination: {
    required: true,
    type: Object
  }
})
const edit = ref(null)
const eateries = computed(() => store.eateries.filter(eatery => eatery.destination_id === props.destination.id))

const editEatery = (eatery) => {
  edit.value = eatery
}

const addEatery = (eatery) => {
  showModal.value = false
  axios.post(route('api.proposal.destination.itinerary.store', {proposal: store.proposal.id, destination: props.destination.id, type: 'eatery'}), {
    place_id: eatery.id,
    name: eatery.name
  }).then(() => {
    store.fetchEateries();
  })
}

const addCustomEatery = (eatery) => {
  showModal.value = false
  axios.post(route('api.proposal.destination.itinerary.store', {proposal: store.proposal.id, destination: props.destination.id, type: 'eatery'}), {
    place_id: eatery?.place_id,
    custom_itinerary_id: eatery.id,
    name: eatery.name
  }).then(() => {
    store.fetchEateries();
  })
}

const deleteEatery = () => {
  axios.delete(route('api.proposal.destination.itinerary.destroy', {proposal: store.proposal.id, destination: props.destination.id, itinerary: edit.value.id})).then(() => {
    edit.value = null
    store.fetchEateries();
  })
}

function cancel() {
  showModal.value = false
}

</script>
